function Svg({ children, className = 'ui-icon', ...props }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconHome() {
  return <Svg><path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1z" /></Svg>;
}

export function IconAssessment() {
  return <Svg><rect x="5" y="4" width="14" height="16" rx="2" /><path d="M8 9h8M8 13h6" /></Svg>;
}

export function IconResults() {
  return <Svg><path d="M5 19V10M10 19V5M15 19v-7M20 19V8" /></Svg>;
}

export function IconConsultations() {
  return <Svg><path d="M4 18V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8z" /><path d="m16 13 4 3v-8l-4 3" /></Svg>;
}

export function IconNotifications() {
  return <Svg><path d="M6 16h12l-1.2-2.2A6 6 0 0 1 16 10V9a4 4 0 1 0-8 0v1a6 6 0 0 1-0.8 3.8z" /><path d="M10 18a2 2 0 0 0 4 0" /></Svg>;
}

export function IconSupport() {
  return <Svg><circle cx="12" cy="12" r="8" /><path d="M9.5 9.5a2.5 2.5 0 1 1 3.6 2.2c-.7.4-1.1.9-1.1 1.8V14" /><circle cx="12" cy="17" r="0.6" fill="currentColor" stroke="none" /></Svg>;
}

export function IconProfile() {
  return <Svg><circle cx="12" cy="8" r="3.2" /><path d="M5.5 19a6.5 6.5 0 0 1 13 0" /></Svg>;
}

export function IconMenu() {
  return <Svg><path d="M4 7h16M4 12h16M4 17h16" /></Svg>;
}

export function IconClose() {
  return <Svg><path d="M6 6l12 12M18 6 6 18" /></Svg>;
}

export function IconArrow() {
  return <Svg className="ui-icon ui-icon-arrow"><path d="M9 6l6 6-6 6" /></Svg>;
}

export function IconDanger() {
  return <Svg><circle cx="12" cy="12" r="8" /><path d="M12 8v5" /><circle cx="12" cy="16.2" r="0.7" fill="currentColor" stroke="none" /></Svg>;
}

export function IconCheck() {
  return <Svg><path d="M5 12.5 10 17l9-10" /></Svg>;
}

export const DASHBOARD_ICONS = {
  home: IconHome,
  assessment: IconAssessment,
  results: IconResults,
  consultations: IconConsultations,
  notifications: IconNotifications,
  support: IconSupport,
  profile: IconProfile,
};
